/*
 * @Author: Jhonsem
 * @Date: 2018-10-25 20:34:43
 * @Last Modified by: mayqiyue
 * @Last Modified time: 2019-06-05 17:05:15
 */
import { ActionTree } from "vuex";
import * as types from "@/store/constants/types";
import {
  getInsUserInfoById,
  getInsUserMediaById,
  searchInsUser
} from "@/api/http/ins/insUser";
import generalUtilsHelper from "@/utils/generalUtils";
import { disconnectUser, transferMasterAccount } from "@/api/http/gx/gxUser";
import { getUserProfile, getUserFeed } from "@/api/http/ins/web/webUserInfo";
import Http from "@/api/http/fetch/index";
import { getAppVersion, isIos } from "@/utils/lodash";
import { routerStackModule, routerInclude } from "@/utils/routerStackUtil";
import { advertisementAct, advertisementList } from "@/api/http/gx/gxUser";
import EventBus from "@/utils/eventBus";
import { judgeVersion } from "@/utils/judgeVersion";
import {
  initialProcessState,
  updateProcessState
} from "@/utils/initialProcessState";
import { sendErrorEventToWindow } from "@/utils/analytics";
import Base64 from "crypto-js/enc-base64";
import Utf8 from "crypto-js/enc-utf8";

const actions: ActionTree<any, any> = {
  async [types.ADD_USER]({ state, commit, dispatch, getters }, payload: any) {
    try {
      const { currentUserId, masterUserId, deviceId, userList } = state;
      console.log("ADD_USER Payload:", payload);
      const { username, userType } = payload;
      let { userId } = payload;
      userId ? (userId = parseInt(userId)) : void 3;
      //先判断如果添加的用户在列表内，提示不要重复登陆：
      const findUser = userList.find((user: any) => {
        return userId
          ? user.userId.toString() === userId.toString()
          : user.userName.toLowerCase() === username.toLowerCase();
      });
      if (findUser !== undefined) {
        //如果用户是搜索账号 或者 登陆账号，可以登陆：
        if (userType === "search" && findUser.userType === "login") {
          return Promise.reject("Cannot login again");
        }
      }

      /**
       * 拉取完毕后进行store的变更：
       * 1.改变当前用户
       * 2.更新index内的总的用户列表
       * 3.更新ins_user_info
       * 4.更新ins_media 更新media_max_id 更新media_load_more_tags
       * 5.更新gx_service模块
       * 6.更新user_status模块
       */

      let insUserInfo: any;
      let insUserMedia: any;

      if (userId) {
        //通过普通的ins登陆的用户：
        [insUserInfo, insUserMedia] = await Promise.all([
          getInsUserInfoById(userId),
          getInsUserMediaById(userId)
        ]);
      } else {
        //webapi的特殊性：1.必须先拉取profile 2.再拉取mediaInfo 3.profile用username拉取的信息
        const login_id = getters[types.GETTER_INS_LOGIN_USER_ID];
        insUserInfo = await searchInsUser(username, login_id);
        userId = insUserInfo.user.pk;
        insUserMedia = await getInsUserMediaById(userId);
        console.log("insUserInfo webapi:", insUserInfo);
        console.log("insUserMedia webapi:", insUserMedia);
      }

      // 需要关联登陆过的账户：
      dispatch(types.LINK_ACCOUNT, {
        masterId: masterUserId,
        userId,
        insUserInfo: insUserInfo.user
      });

      //==================== Commit =====================
      commit(types.ADD_USER, {
        userId,
        insUserInfo: insUserInfo.user,
        userType
      });
      commit(types.RECEIVE_INS_USER_INFO_DATA, {
        userId,
        insUserInfo: insUserInfo.user
      });
      commit(types.RECEIVE_INS_USER_MEDIA_LIST_DATA, {
        userId,
        insUserMedia
      });
      if (
        insUserMedia.hasOwnProperty("items") &&
        insUserMedia.items.length !== 0
      ) {
        commit(types.CHANGE_CURRENT_INS_POST_ID, insUserMedia.items[0]);
        const findView = insUserMedia.items.find((item: any) => {
          return item.media_type === 2;
        });
        if (findView === undefined || findView === null) {
          commit(types.CHANGE_CURRENT_INS_VIEW_ID, null);
        } else {
          commit(types.CHANGE_CURRENT_INS_VIEW_ID, findView);
        }
      } else {
        commit(types.CHANGE_CURRENT_INS_VIEW_ID, null);
        commit(types.CHANGE_CURRENT_INS_POST_ID, null);
      }
      //增加新的用户:
      if (userType === "login") {
        commit(types.ADD_USER_STATUS, userId);
      }
      //判断是否是被gx banned的用户:userId

      //需要判断返回到Home的哪一个子路由：
      const { homeActiveIndex, routerStack } = routerStackModule;
      console.log("homeActiveIndex:", homeActiveIndex);
      const loginRouter = routerStack.find((v: any) => v.name === "Login");
      const followersRouter = routerStack.find(
        (v: any) => v.name === "Followers"
      );
      let temp_state = true; // 临时状态，如果进入了上面的判断，就不进入下面的判断

      //如果是第一个帐号而且不是搜索，并且不是vip，需要跳转到vip界面:
      if (userType === "login") {
        //================路由的跳转===============

        if (homeActiveIndex === 2) {
          //从earn coins来的
          dispatch(types.ROUTER_PUSH, {
            name: "EarnCoin",
            params: {
              routerTransition: "forward"
            }
          });
        } else {
          // if (!routerInclude("Home")) {
          //   // 从开机弹框，主界面没有初始化
          //   dispatch(types.INITIAL_ROUTE_TO_MAIN_TAB);
          // } else {
          //   dispatch(types.ROUTER_PUSH, {
          //     name: "Followers",
          //     params: {
          //       routerTransition: "forward",
          //       comeFromNotice: false
          //     }
          //   });
          // }
          // 如果从splash页面进登陆
          if (
            (loginRouter &&
              loginRouter.params &&
              loginRouter.params.from === "splash") ||
            !followersRouter
          ) {
            temp_state = false;
            dispatch(types.INITIAL_ROUTE_TO_MAIN_TAB);
          } else {
            dispatch(types.ROUTER_PUSH, {
              name: "Followers",
              params: {
                routerTransition: "forward",
                comeFromNotice: false
              }
            });
          }
        }
      }

      //更新原生的masterId和状态
      dispatch(types.UPDATE_NATIVE_LOGIN_STATUS);
      // 如果有未手动关闭或者已购买的recommendOffer,进入订单页
      console.log(
        "initialProcessState.recommendOffer: ",
        initialProcessState.recommendOffer
      );
      if (initialProcessState.recommendOffer) {
        dispatch(types.PAY_BY_ANY, {
          offer: initialProcessState.recommendOffer
        });
        updateProcessState({ key: "recommendOffer", offer: null });
        return;
      }

      // 如果不存在绑定页面并且不是vip
      if (homeActiveIndex !== 2 && !routerInclude("AccountBind")) {
        // 如果当前页面就是vipCenter，则不再跳转
        const vipIndex = routerStack.findIndex(
          (v: any) => v.name === "VipCenter" || v.name === "VipCenterPlanB"
        );

        if (vipIndex !== 0 && temp_state) {
          // 如果最近一次的登录是由freeFollowersDialog弹窗过来
          console.log("temp_state");
          if (
            loginRouter &&
            loginRouter.query &&
            loginRouter.query.from === "freeFollowersDialog" &&
            userType !== "search"
          ) {
            console.log("REQUEST_FREE_FOLLOWERS");
            dispatch(types.REQUEST_FREE_FOLLOWERS);
          } else {
            if (!generalUtilsHelper.isVip()) {
              dispatch(types.ROUTER_PUSH, {
                name: "VipCenter",
                params: {
                  routerTransition: "up"
                },
                query: {
                  type: "single",
                  popUp: true,
                  from:
                    loginRouter &&
                    loginRouter.params &&
                    loginRouter.params.from === "splash"
                      ? "root"
                      : "" // 如果是从splash登陆过来，则代表初始化
                }
              });
            }
          }
        }
      } else if (routerInclude("AccountBind")) {
        let index: number = userType === "login" ? -2 : 0; // 为什么login情况下是-2，因为会先push一层followers进去
        if (routerInclude("LoginSelect")) {
          index--;
        }
        if (routerInclude("ChallengeRequire")) {
          index--;
        }
        if (routerInclude("SecurityCode")) {
          index--;
        }
        index !== 0 && dispatch(types.ROUTER_GO_BACK, index);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [types.CLEAR_LOGIN_USER](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      console.log("CLEAR_LOGIN_USER ");
      //============== Cookie ====================
      Http.ClearAllCookies(); //清除本地的cookie
      //=============== Ins USER =================
      const { userList } = state;
      const findUser = userList.find((user: any) => {
        return user.userType === "search";
      });
      if (findUser) {
        //如果有search的用户
        commit(types.CHANGE_CURRENT_USER, findUser.userId);
        commit(types.CLEAR_LOGIN_USER); //masterId置为null
        //删除用户
        let i = userList.length;
        while (i--) {
          userList[i].userType === "login"
            ? commit(types.DELETE_USER, userList[i].userId)
            : void 3;
        }
      } else {
        //没有search用户，清除所有的信息
        commit(types.CLEAR_ALL_USER);
      }
      //将gx userInfo 通过device id去拉取：
      const masterId = getters[types.GETTER_DEVICE_ID];
      dispatch(types.LOGIN_BY_GX, {
        masterId
      });

      //更新原生的masterId和状态
      dispatch(types.UPDATE_NATIVE_LOGIN_STATUS);
    } catch (error) {
      console.log("CLEAR_LOGIN_USER error:", error);
    }
  },
  async [types.DELETE_USER](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      const { userId, userType } = payload;

      const deleteUser = () => {
        if (userId.toString() === state.currentUserId.toString()) {
          //退出的账户为当前的账户：
          if (state.userList.length === 1) {
            //退出的为最后一个账户
            commit(types.CLEAR_INS_USER); //gx master service不能清除

            //回到欢迎登录页面：
            dispatch(types.ROUTER_REPLACE, {
              name: "Splash",
              params: { routerTransition: "up" }
            });
          } else {
            //不是最后一个账户：
            for (const user of state.userList) {
              if (user.userId.toString() !== userId.toString()) {
                commit(types.CHANGE_CURRENT_USER, user.userId);
                break;
              }
            }
          }
        }
        //取消关联：
        if (userType === "login") {
          dispatch(types.DISCONNECT_USER, {
            masterId: state.masterUserId,
            userId
          });
        }
        commit(types.DELETE_USER, userId);
      };

      dispatch(types.ACTOIN_SHEET_SHOW, {
        title: "Are you sure you want to remove this account?",
        sheets: [
          {
            text: "Remove",
            textColor: "rgb(0,192,188)",
            Fn: deleteUser
          },
          {
            text: "Cancel",
            Fn: () => {}
          }
        ]
      });
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [types.DISCONNECT_USER]({ state, commit, dispatch }, payload: any) {
    try {
      const { masterId, userId } = payload;
      const result = await disconnectUser(masterId, userId);
      dispatch(types.RECEIVE_GX_MASTER_SERVER_DATA, result);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [types.GETTER_IDFA]({ state, commit, dispatch }, payload: any) {
    try {
      const idfaRequest = new Promise((resolve, reject) => {
        Http.GetIDFA()
          .then((idfaResult: any) => {
            //如果连续出现4个0,则就是用户禁止了idfa:
            if (idfaResult.indexOf("0000") > -1) {
              reject(false);
            } else {
              resolve(idfaResult);
            }
          })
          .catch((error: any) => {
            reject(false);
          });
      });

      const timeOutResult = new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(false);
        }, 200);
      });

      const result = await Promise.race([idfaRequest, timeOutResult]);
      return result;
    } catch (error) {
      return false;
    }
  },
  async [types.GETTER_IDFV]({ state, commit, dispatch }, payload: any) {
    try {
      const idfaRequest = new Promise((resolve, reject) => {
        Http.GetIDFV()
          .then((idfaResult: any) => {
            resolve(idfaResult);
          })
          .catch((error: any) => {
            reject(false);
          });
      });

      const timeOutResult = new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(false);
        }, 200);
      });

      const result = await Promise.race([idfaRequest, timeOutResult]);
      return result;
    } catch (error) {
      return false;
    }
  },
  async [types.TRANSFER_MASTER_ID_TO_IDFA](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      console.log("TRANSFER_MASTER_ID_TO_IDFA");
      //先判断是android还是ios:
      if (isIos()) {
        //再尝试拿取idfa:
        const idfaResult = await dispatch(types.GETTER_IDFA);
        const deviceId = getters[types.GETTER_DEVICE_ID];
        const AppInfo: any = await Http.AppInfo();
        const oldPlatform: string = AppInfo.GETX_PLATFORM;
        if (idfaResult && idfaResult !== deviceId) {
          //获取到了idfa，并且idfa和deviceID不相同:
          console.log("获取到了idfa，并且idfa和deviceID不相同:", {
            idfaResult,
            deviceId
          });
          const transferResult: any = await transferMasterAccount(
            deviceId,
            idfaResult,
            oldPlatform
          );
          console.log("Http transferResult:", transferResult);
          //先发请求，如果请求成功，再将本地的device id 置为 idfa:
          commit(types.UPDATE_DEVICE_ID, idfaResult);
          commit(types.RECEIVE_GX_MASTER_SERVER_DATA, transferResult.user_info);
          return true;
        }
      }
    } catch (error) {
      console.log("TRANSFER_MASTER_ID_TO_IDFA error:", error);
      return false;
      // return Promise.reject(error);
    }
  },
  async [types.UPDATE_DEVICE_ID]({ state, commit, dispatch }, payload: any) {
    try {
      const getIdfaResult = async () => {
        const idfaRequest = new Promise((resolve, reject) => {
          Http.GetIDFA()
            .then((idfaResult: any) => {
              //如果连续出现4个0,则就是用户禁止了idfa:
              if (idfaResult.indexOf("0000") > -1) {
                resolve(false);
              } else {
                resolve(idfaResult);
              }
            })
            .catch((error: any) => {
              resolve(false);
            });
        });

        const timeOutResult = new Promise((resolve, reject) => {
          setTimeout(() => {
            resolve(false);
          }, 200);
        });

        const result = await Promise.race([idfaRequest, timeOutResult]);
        return result;
      };

      if (
        state.deviceId === null ||
        state.masterUserId === null ||
        typeof state.masterUserId === "number" ||
        typeof state.masterUserId === "object"
      ) {
        //如果设备ID为空的话，或者他是老用户，masterId是number,需要从原生拿取：
        //先从idfa拿，如果有idfa就用，没有则用deviceId

        if (isIos()) {
          //先尝试用idfa去拿,如果拿不到就用deviceId:
          const idfaResult = await getIdfaResult();
          // if (idfaResult) {
          if (idfaResult) {
            //如果拿到了idfa的结果:
            commit(types.UPDATE_DEVICE_ID, idfaResult);
          } else {
            //如果拿不到idfa的结果
            const result: any = await Http.DeviceId();
            console.log("deviceID", result);
            commit(types.UPDATE_DEVICE_ID, result);
          }
        } else {
          //安卓就拿deviceID，别多想了
          const result: any = await Http.DeviceId();
          if (typeof result === "object" && result.DEVICE_ID) {
            commit(types.UPDATE_DEVICE_ID, result.DEVICE_ID);
            return;
          }
          commit(types.UPDATE_DEVICE_ID, result);
        }
      }
    } catch (error) {
      sendErrorEventToWindow("UPDATE_DEVICE_ID", error);
      return Promise.reject(error);
    }
  },
  async [types.UPDATE_NATIVE_LOGIN_STATUS](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    //IOS这个时候需要知道master_id:
    const masterId =
      getters[types.GETTER_MASTER_ID] || getters[types.GETTER_DEVICE_ID];
    Http.ChangeMasterId({
      isLoginUser: true,
      masterId
    });
  },
  // 单个查询app的状态，ios ok代表已经安装，安卓result === true代表已安装
  async [types.REQUEST_APP_STATE]({ state, commit, dispatch }, payload: any) {
    try {
      return new Promise((resolve, reject) => {
        Http.UpdateResourceStatus(payload)
          .then((result: any) => {
            if (result === "ok" || result === "true") {
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch(() => {
            resolve(false);
          });
      });
      // const timeOutResult: any = new Promise((resolve, reject) => {
      //   setTimeout(() => {
      //     resolve(false);
      //   }, 1000);
      // });
      // return await Promise.race([requestResult, timeOutResult]);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  // 获取当前可展示的app的列表
  [types.SELECT_APP_STATE]({ state, commit, dispatch, getters }, payLoad) {
    try {
      Http.ADRecommend().then(async (result: any) => {
        console.log("ADRecommend result:", result);
        let data = result && result.data;
        if (!isIos() && judgeVersion(getAppVersion(), "4.9.0") && data) {
          data = Base64.parse(data).toString(Utf8);
          data = JSON.parse(data);
        }
        data = data || [];
        // 性能消耗大，去掉本地过滤过程。2019.4.17
        // const judgeInterFaceExist = getters[types.GETTER_JUDGE_INTERFACE_EXIST];
        // let unInstalledApp: any = [];
        // console.log("judgeInterFaceExist:", {
        //   judgeInterFaceExist,
        //   data
        // });
        // if (judgeInterFaceExist) {
        //   await Promise.all(
        //     data.map(async (info: any) => {
        //       const installed = await dispatch(
        //         types.REQUEST_APP_STATE,
        //         info.packageName
        //       );
        //       !installed && unInstalledApp.push(info);
        //     })
        //   );
        // } else {
        //   unInstalledApp = data;
        // }
        console.log("unInstalledApp=", data);
        commit(types.UPDATE_UNINSTALLED_LIST, data);
        payLoad && payLoad();
      });
    } catch (error) {
      return Promise.reject(error);
    }
  },
  // 获取当前摄像头和相册的权限
  async [types.CAMERA_AND_ALBUM_ENABLED]() {
    try {
      const cameraEnabled: any = new Promise((resolve, reject) => {
        Http.CameraAuthorityEnabled()
          .then((result: any) => {
            console.log("CameraAuthorityEnabled:", result);
            resolve(result === "ok");
          })
          .catch((error: any) => {
            resolve(false);
          });
      });

      const albumEnabled: any = new Promise((resolve, reject) => {
        Http.AlbumAuthorityEnabled()
          .then((result: any) => {
            console.log("CameraAuthorityEnabled:", result);
            resolve(result === "ok");
          })
          .catch((error: any) => {
            resolve(false);
          });
      });

      const valid = await generalUtilsHelper.iosJudgeVersion("4.4.0");

      if (valid) {
        // return await Promise.all([cameraEnabled, albumEnabled]);
        return albumEnabled;
      } else {
        // return [false, false]
        return false;
      }
    } catch {
      // return [false, false]
      return false;
    }
  },
  [types.REQUEST_ADMOB_AVAILABLE]({ state, commit, dispatch, getters }) {
    return new Promise(async (resolve, reject) => {
      if (!isIos()) {
        const masterId =
          getters[types.GETTER_MASTER_ID] || getters[types.GETTER_DEVICE_ID];
        const AppInfo: any = await Http.AppInfo();
        const platform: any = AppInfo.GETX_PLATFORM;
        console.log("platform:", platform);
        const result3: any = await advertisementList(
          masterId,
          platform,
          JSON.stringify(["admob"])
        );
        console.log("advertisementList: ", result3);
        resolve(result3 && result3.admob && result3.admob.is_allowd);
      } else {
        resolve(true);
      }
    });
  },
  async [types.WATCH_VIDEO](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      const checkSignGxUserResult = await dispatch(types.CHECK_GX_USER_LOGINED);
      if (!checkSignGxUserResult) {
        return;
      }
      const { videoName, reward, admob_enabled, callback } = payload;
      let requestData: any;
      const masterId =
        getters[types.GETTER_MASTER_ID] || getters[types.GETTER_DEVICE_ID];

      if (isIos()) {
        requestData = videoName;
      } else {
        const userAgent = getAppVersion();
        requestData = judgeVersion(userAgent, "4.0.0")
          ? { reward, admob_enabled }
          : videoName;
      }
      console.log("requestData: ", requestData);
      const result: any = await Http.IsVideoAvailable(requestData);
      console.log("IsVideoAvailable result:", result);

      if (result === "1" || result === "true") {
        Http.PlayVideo(requestData)
          .then(async (res: any) => {
            console.log("看视频的结果", res);
            if (isIos()) {
              if (res === "Video play completed") {
                callback && callback();
              } else {
                EventBus.$emit("toast-show", {
                  type: "warning",
                  content: (res && res.msg) || "watch failed",
                  duration: 1000
                });
              }
            } else {
              if (res === "admob") {
                const AppInfo: any = await Http.AppInfo();
                const platform: any = AppInfo.GETX_PLATFORM;
                await advertisementAct(masterId, platform, "admob");
                callback && callback();
              } else if (res === "vungle" || res === "applovin") {
                console.log("ads type: ", res);
                callback && callback();
              } else {
                EventBus.$emit("toast-show", {
                  type: "warning",
                  content: (res && res.error) || "watch failed",
                  duration: 1000
                });
              }
            }
          })
          .catch(err => {
            console.log("看视频错误err", err);
          });
      } else {
        EventBus.$emit("toast-show", {
          type: "warning",
          content: "Video is not ready yet.",
          duration: 2000
        });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [types.SHAKE_PLAY]({}, payload: any) {
    const judgeShakeInterface = async () => {
      const appInfo: any = await Http.AppInfo();
      const userAgent = getAppVersion();
      let versionNew: any = false;
      if (isIos()) {
        versionNew =
          appInfo &&
          appInfo.CODE_VERSION &&
          judgeVersion(appInfo.CODE_VERSION, "4.5.0");
      } else {
        versionNew = judgeVersion(userAgent, "4.5.0");
      }
      return versionNew;
    };

    const canShake = await judgeShakeInterface();
    if (!canShake) {
      return;
    }
    const { android, ios, name } = payload;
    if (isIos()) {
      const time = ios ? ios : 0;
      Http.Shake(time)
        .then((result: any) => {})
        .catch((err: any) => {});
    } else {
      // 参数shake_one_shot 和 shake_array传其一。参数都是毫秒
      const is_array: boolean = Array.isArray(android);
      const obj = is_array
        ? {
            shake_array: android // 交替振动
          }
        : {
            shake_one_shot: android ? android : 100 // 振动一次
          };
      Http.Shake(obj)
        .then((result: any) => {
          console.log("shake from: ", name);
        })
        .catch((err: any) => {});
    }
  },
  async [types.FETCH_VIDEO_URL_BY_DICT]({ getters }, payload: any) {
    return new Promise(async (resolve, reject) => {
      try {
        const { name, url } = payload;
        const localFiles: any = await Http.GetLocalFiles();
        console.log("localFiles:", localFiles);
        if (localFiles) {
          const result = localFiles.find((v: any) => v.name === name);
          result ? resolve(result.path_url) : resolve(url);
        } else {
          resolve(url);
        }
      } catch (e) {
        reject(e);
      }
    });
  },
  [types.SHOW_LITE_SEARCH_OR_LOGIN]({ getters, dispatch }) {
    if (getters[types.GETTER_INS_LOGIN_USER_ID]) {
      dispatch(types.LITE_SEARCH_POP_SHOW, true);
    } else {
      dispatch(types.ROUTER_PUSH, {
        name: "Login",
        params: {
          routerTransition: "up"
        }
      });
    }
  }
};

export default actions;
